var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "QPIcons/Like/16px Copy 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RESPONDENT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pixel-Slate",
    transform: "translate(-104.000000, -407.000000)",
    fill: "#D8D8D8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "QPIcons/Like/16px-Copy-3",
    transform: "translate(103.000000, 406.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,15 L5,1 L7,1 C8.1045695,1 9,1.8954305 9,3 L9,5 L13,5 C14.1045695,5 15,5.8954305 15,7 L15,13 C15,14.1045695 14.1045695,15 13,15 L5,15 Z M1,5 L4,5 L4,15 L1,15 L1,5 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/Like.39bfe4e9fc232ce16d3a1bf34a634552.svg";
export { ForwardRef as ReactComponent };